import { Link } from 'react-router-dom';
import { mangaData } from '@/mocks/manga';

export default function CTASection() {
  const featured = mangaData.slice(0, 4);

  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="relative overflow-hidden rounded-lg bg-gradient-to-r from-primary-500 to-accent-500 p-8 md:p-12">
          <div className="relative z-10 flex flex-col md:flex-row items-center justify-between gap-8">
            <div className="text-center md:text-left">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-background-50 dark:text-foreground-950 mb-3">
                准备好了吗？开始你的漫画之旅
              </h2>
              <p className="text-sm text-background-100/90 max-w-md">
                海量漫画免费看，下拉式阅读超方便。马上加入樱花漫画，发现更多精彩作品！
              </p>
            </div>
            <Link
              to="/category/all"
              className="flex-shrink-0 px-8 py-3.5 text-sm font-bold bg-background-50 text-primary-600 rounded-full hover:bg-background-100 transition-all whitespace-nowrap cursor-pointer"
            >
              免费开始阅读
            </Link>
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mt-8">
          {featured.map((manga) => (
            <Link
              key={manga.id}
              to={`/manga/${manga.id}`}
              className="flex flex-col items-center gap-2 p-4 bg-background-100 rounded-lg hover:bg-primary-50 transition-all cursor-pointer group"
            >
              <div className="w-16 h-20 rounded-md overflow-hidden">
                <img
                  src={manga.cover}
                  alt={manga.title}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <span className="text-xs font-medium text-foreground-800 group-hover:text-primary-600 transition-colors line-clamp-1 text-center">
                {manga.title}
              </span>
              <span className="text-xs text-foreground-500">{manga.category}</span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}